const selectors = {
  text: '[data-comp-card-slider-text]',
  track: '.splide__track',
  wrapper: '.section-card-slider__wrapper',
};

const splideOptions = {
  type: 'slide',
  gap: 22,
  drag: false,
  padding: {
    right: 48,
  },
  breakpoints: {
    768: {
      drag: true,
      fixedWidth: 258.5,
      padding: {
        left: '20%',
        right: '20%',
      },
    },
  },
};

export { selectors, splideOptions };
